import React from "react";
import PropTypes from "prop-types";
import {Provider} from "react-redux";
import JssProvider from "react-jss/lib/JssProvider";
import {
  MuiThemeProvider,
  createGenerateClassName,
  jssPreset
} from "@material-ui/core/styles";
import {create} from 'jss';
import createStoreForSSR from "./redux";
import Category from "./pages/Category";
import Department from "./pages/Department";
import Root from "./pages/Root";
import {getMuiTheme} from "../../../javascripts/getMaterialTheme";
import { ThemeProvider } from "styled-components";
import { theme } from "../styles/theme";

class App extends React.Component {
  static propTypes = {
    materialUI: PropTypes.string,
    state: PropTypes.shape({
      url: PropTypes.string,
      path: PropTypes.string,
      authenticityToken: PropTypes.string,
      isAdmin: PropTypes.bool,
      products: PropTypes.object,
      breadcrumbs: PropTypes.array
    })
  };
  // Remove the server-side injected CSS.
  componentDidMount() {
    const jssStyles = document.getElementById(
      `jss-server-side-${this.props.materialUI}`
    );
    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
    document
      .querySelector(`[data-react-class]`)
      .removeAttribute(`data-react-props`);
  }

  render() {
    const {
      state: {
        url,
        type,
        isAdmin,
        authenticityToken,
        content,
        menu,
        locationData,
        breadcrumbs,
        onPlatform,
        currency,
        isMobile,
      }
    } = this.props;

    const store = createStoreForSSR({
      url,
      isAdmin,
      authenticityToken,
      content,
      menu,
      locationData,
      breadcrumbs,
      serviceModal: {isOpen: false},
      onPlatform,
      currency,
      isMobile
    });
    const muiTheme = getMuiTheme(onPlatform);
    // Create a new class name generator.
    const generateClassName = createGenerateClassName({
      productionPrefix: `${this.props.materialUI}-react-app`
    });
    const jss = create({
      ...jssPreset(),
      // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
      insertionPoint: typeof document !== 'undefined' && document.getElementById('jss-insertion-point'),
    });

    return (
      <JssProvider jss={jss} generateClassName={generateClassName}>
        <MuiThemeProvider theme={muiTheme}>
          <ThemeProvider theme={theme}>
            <Provider store={store}>
              {type === `category` && <Category />}
              {type === `department` && <Department />}
              {type === `root` && <Root />}
            </Provider>
          </ThemeProvider>
        </MuiThemeProvider>
      </JssProvider>
    );
  }
}

export default App;
